import { Button, Modal } from 'react-bootstrap';

import React, { useState } from 'react';
import { useAppSelector } from '../../../../../redux/store';

import { notify, notifyError } from '../../../../notify/notify-component';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { StateForm } from '../../../../../interfaces/state-form';
import { Services } from '../../../../../Services/newService';
import { InputHookCnpjPeople } from '../../../../reactHookForm/InputHookCnpjPeople';
import { InputHook } from '../../../../reactHookForm/InputHook';
import { peopleSchemaProduct } from '../../../../../schemas/peopleSchema-product';
import * as S from './styled';
import { getVendorAsync } from '../../../../../redux/features/product/services';

interface IProps {
  show: boolean;
  setShow: any;
  dispatch: any;
}

type FormData = Yup.InferType<typeof peopleSchemaProduct>;

interface IInput {
  cpf_cnpj: string;
  company_name: string;
}

export default function ModalSupplier({ show, setShow, dispatch }: IProps) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const [stateForm, setStateForm] = useState<StateForm>({
    state: 'default',
    message: '',
  });

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    setError,
    formState,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(peopleSchemaProduct),
  });

  const handleClose = () => {
    const newData = {
      cpf_cnpj: null,
      company_name: '',
    };
    //reset(newData);
    setShow(false);
  };

  const onSubmit: SubmitHandler<FormData> = async (data: FormData) => {
    setStateForm({ state: 'loading' });

    const newData: Record<string, unknown> = {
      ...data,
      name: data.company_name,
      email: data.email || '',
      store_id: storeMe?.storeActive?.id,
      is_vendor: true,
    };

    if (!data.trading_name) {
      delete newData.trading_name;
    }
    try {
      const res = await Services.people(newData, setStateForm);
      if (res?.status === 200) {
        notify(`Fornecedor cadastrado.`);
        dispatch(getVendorAsync(storeMe?.storeActive?.id));
        setStateForm({ state: 'send' });
        handleClose();
      }
    } catch (err: any) {
      const erroAxios = err?.response?.data?.errors;
      const erroHandler = erroAxios ? Object.values(erroAxios)[0] : err;

      if (typeof erroHandler === 'string') {
        const parseError = JSON.parse(erroHandler);
        notifyError(parseError.cause[0].message || `Erro ao cadastrar.`);
        setStateForm({ state: 'error' });
        return;
      }
    }
  };

  const inputError = [errors];

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <S.StyledHeader closeButton>
          <Modal.Title>
            <S.TitleWrapper>
              <S.IconCircle>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="1" y="6" width="14" height="10" rx="1" />
                  <path d="M15 10h4l3 3v3h-7z" />
                  <circle cx="6" cy="18.5" r="1.8" />
                  <circle cx="17.5" cy="18.5" r="1.8" />
                </svg>
              </S.IconCircle>
              <div>
                <h3>Novo Fornecedor</h3>
                <span>Cadastre um fornecedor para vincular ao produto</span>
              </div>
            </S.TitleWrapper>
          </Modal.Title>
        </S.StyledHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <S.Wrapper>
              <InputHookCnpjPeople
                register={register}
                watch={watch}
                setValue={setValue}
                setError={setError}
                errors={inputError}
                reset={reset}
                setStateForm={setStateForm}
                label="CNPJ"
                //mask="99.999.999/9999-99"
                name="cpf_cnpj"
                placeholder="Informe o CNPJ"
                path={'vendor'}
                setArrayContacts={[]}
                setArrayAdress={[]}
              />

              <InputHook
                register={register}
                errors={inputError}
                label="Razão social"
                name="company_name"
                placeholder="Razão social"
                type="text"
                disabled={stateForm.state === 'loading'}
              />

              <InputHook
                register={register}
                errors={inputError}
                label="Nome fantasia"
                name="trading_name"
                placeholder="Nome fantasia"
                type="text"
                disabled={stateForm.state === 'loading'}
              />

              <InputHook
                register={register}
                errors={inputError}
                label="Email"
                name="email"
                type="text"
                placeholder="Email"
                disabled={stateForm.state === 'loading'}
              />
            </S.Wrapper>
          </Modal.Body>
          <S.StyledFooter>
            <Button variant="light" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={stateForm.state === 'loading'}
            >
              {stateForm.state === 'loading' ? 'Salvando...' : 'Salvar'}
            </Button>
          </S.StyledFooter>
        </form>
      </Modal>
    </>
  );
}
